// @flow

export default {
  MAXIMUM_IN_CART: 99,
  MAX_AMOUNT_SELECTOR: 10
};
